module.exports = __webpack_public_path__ + "img/a3-s58.e6249f9d.jpg";